import React, { useState } from 'react';
import cn from 'classnames';
// eslint-disable-next-line no-restricted-imports
import { Link } from 'shared/ui/Link';
import {
    Button,
    InfoDialog,
    TextArea,
    createLeadThunk,
    useAppDispath,
} from 'shared';
import {
    Field, Grid, Input, Text,
} from '@chakra-ui/react';
import { Controller, useForm } from 'react-hook-form';
import BaseError from 'utils/base-error';
import ym from 'react-yandex-metrika';
import styles from './LeadForm.module.scss';
// import {
//     Input,
//     InputTheme,
//     TextArea,
//     TextAreaTheme,
// } from '../../shared';
// import { Button } from '../button/Button';

type FormValues = {
    name: string
    phone: string
    comment: string
}

export type LeadFormProps = {
    className?: string;
    title: string
    subtitle: string
    pdf?: {
        url: string
    },
    hasTextArea?: boolean
}

export const LeadForm = ({
    className,
    title,
    subtitle,
    hasTextArea = false,
    pdf,
}: LeadFormProps) => {
    const [open, setOpen] = useState(false);
    const [title2, setTitle2] = useState('');
    const [text, setText] = useState('');
    const dispatch = useAppDispath();

    const [pending, setPending] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm<FormValues>();

    const onSubmit = handleSubmit(async (data) => {
        setPending(true);

        dispatch(createLeadThunk({
            name: data.name,
            phone: data.phone,
            comment: data.comment,
        })).then(({ payload }) => {
            if (payload instanceof BaseError) {
                setTitle2('Ошибка при отправке');
                setText('Обновите страницу или попробуйте позже');
            } else {
                setTitle2('Заявка отправлена');
                setText('Наши специалисты свяжутся с вами в ближайшее время');
            }
            ym('reachGoal', 'corso-catering.ru/lead');
            setOpen(true);
        }).catch(() => {
            console.log();
        }).finally(() => {
            setPending(false);
        });
    });

    return (
        <Grid className={cn(className, styles.leadForm)} templateRows="auto auto 1fr">
            <Text
                className={styles.leadForm__title}
                lineHeight={1}
            >
                {title}
            </Text>
            <span className={styles.leadForm__subtitle}>
                {subtitle}
            </span>
            <form onSubmit={onSubmit}>
                <Grid
                    gap="1rem"
                    color="white"
                    templateRows={hasTextArea ? 'auto auto 1fr auto' : undefined}
                    height="100%"
                >
                    <Controller
                        name="name"
                        control={control}
                        rules={{
                            required: 'Поле не может быть пустым',
                        }}
                        render={({ field }) => (
                            <Field.Root invalid={errors.name}>
                                <Input
                                    {...field}
                                    placeholder="Ваше имя"
                                    inputMode="text"
                                    height="100%"
                                />
                                <Field.ErrorText fontSize="1rem">
                                    {errors.name?.message}
                                </Field.ErrorText>
                            </Field.Root>
                        )}
                    />
                    <Controller
                        name="phone"
                        control={control}
                        rules={{
                            required: 'Поле не может быть пустым',
                        }}
                        render={({ field }) => (
                            <Field.Root invalid={errors.phone}>
                                <Input
                                    {...field}
                                    placeholder="Номер телефона"
                                    inputMode="tel"
                                    height="100%"
                                />
                                <Field.ErrorText fontSize="1rem">
                                    {errors.phone?.message}
                                </Field.ErrorText>
                            </Field.Root>
                        )}
                    />
                    {hasTextArea && (
                        <Controller
                            name="comment"
                            control={control}
                            render={({ field }) => (
                                <Field.Root invalid={errors.comment}>
                                    <TextArea
                                        {...field}
                                        placeholder="Что вы хотите узнать?"
                                        height="100%"
                                        border="2px solid #FFFFFF"
                                    />
                                    <Field.ErrorText fontSize="1rem">
                                        {errors.comment?.message}
                                    </Field.ErrorText>
                                </Field.Root>
                            )}
                        />
                    )}
                    <Button
                        colorScheme="accent"
                        size="lg"
                        height="100%"
                        type="submit"
                        loading={pending}
                    >
                        Записаться
                    </Button>
                    {pdf && (
                        <>
                            <div className={styles.leadForm__divider}>
                                <div />
                                <span>или</span>
                                <div />
                            </div>
                            <Link
                                className={styles.leadForm__pdfLink}
                                to={pdf?.url || ''}
                                target="_blank"
                            >
                                <span>Скачать презентацию</span>
                            </Link>
                        </>
                    )}
                </Grid>
            </form>
            <InfoDialog
                title={title2}
                open={open}
                setOpen={setOpen}
                body={
                    <Text>{text}</Text>
                }
            />
        </Grid>
    );
};
